<template lang="pug">
  a.AK-List_User(:href="`#user-${userData.index}`")
    .AK-List_User_Image_Wrap
      .AK-List_User_Counter No.{{userData.index + 1}}
      .AK-List_User_Image(
        :style="`background-image: url(${userData.profile_image})`"
      )
        .AK-List_User_New(v-if="isNew") New!
    .AK-List_User_Info
      .AK-List_User_Title {{userData.title}}
      .AK-List_User_Meta
        span.AK-List_User_Area(v-if="user.action_prefecture_names")
          | {{user.action_prefecture_names}}在住
        span.AK-List_User_Age
          | {{userData.age}}才{{user.profile.gender}}
        span.AK-List_User_Name {{userData.name}} さん
        span.AK-List_User_Name | エリア：{{areasDisplay}}
      .AK-List_User_Summary(v-html="userData.hope")

</template>
<script>
  export default {
    props: {
      user: {
        type: Object,
        required: true,
      },
      userData: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        newVolume: 2,
      };
    },
    computed: {
      isNew() {
        return this.userData.volume === this.newVolume;
      },
      areasDisplay() {
        return (this.userData.areas || []).join(', ');
      },
    },
  };
</script>
